import { ChartTimingTypes, JobsChartSegments, SortTypes } from "../../../../core/Enums"

export interface JobsReportRequest {
    chartTiming: ChartTimingTypes
    segment: JobsChartSegments
    segmentIds: string[]
    metric1: string
    metric2: string
    metric3: string
    dateId: string
    dateName?: string
    startDate?: string
    toDate?: string
    timezone?: string
    dateType?: string
}

// The two bases a jobs report can be matched against, and the rule for which one applies
// when the user has not chosen explicitly. This MIRRORS the backend rule in
// DataService.JobsReports.GenerateJobsReport: an unset dateType keeps each segment's
// historical default -- Agents by creation date, every other segment by last status update.
// Keep both sides in sync if this ever changes.
export const REPORT_DATE_TYPES = [
    { id: "1", name: "Last Status Date" },
    { id: "2", name: "Created Date" }
]

// Windows names its synthetic UTC zones "(UTC-11:00) Coordinated Universal Time-11" -- the
// offset already leads the label, so the trailing repeat is noise. Real place names like
// "(UTC+03:00) Istanbul" are left exactly as they are.
export const timezoneLabel = (name?: string): string => {
    var n = name ?? ""
    if (n.indexOf("Coordinated Universal Time") < 0) return n
    return n.replace(/[+-]\d{1,2}$/, "").trim()
}

export const effectiveDateType = (body?: JobsReportRequest): string => {
    if (body?.dateType) return body.dateType
    return body?.segment == JobsChartSegments.Dispatchers ? "2" : "1"
}

export const dateTypeName = (dateType?: string): string =>
    dateType == "2" ? "Created Date" : "Last Status Date"


export interface JobsReportSort {
    sortKey: string
    sortType: SortTypes
    sortLoading?: boolean
}


export interface JobReportVisibility {
    jobId?: boolean
    name?: boolean
    phone?: boolean
    jobType?: boolean
    jobSource?: boolean
    metro?: boolean
    address?: boolean
    created?: boolean
    closed?: boolean
    invoiceNumber?: boolean
    total?: boolean
    cash?: boolean
    ccmanual?: boolean
    cccharge?: boolean
    check?: boolean
    coParts?: boolean
    techParts?: boolean
    coProfits?: boolean
    techProfits?: boolean
    sourceProfits?: boolean
    techBalance?: boolean
}